import React from 'react'
import {Icon} from '@chakra-ui/react'

const ProductRegistrationIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" fill="none" {...props}>
            <path
                d="M22.6667 21.3331V15.3331C22.6667 13.3331 24 13.3331 24 10.6664C24 9.60558 23.5786 8.58816 22.8284 7.83802C22.0783 7.08787 21.0609 6.66644 20 6.66644C18.9391 6.66644 17.9217 7.08787 17.1716 7.83802C16.4214 8.58816 16 9.60558 16 10.6664C16 13.3331 17.3333 13.3331 17.3333 15.3331V21.3331"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M30.6663 24.6664C30.6663 23.7823 30.3152 22.9345 29.69 22.3094C29.0649 21.6843 28.2171 21.3331 27.333 21.3331H12.6663C11.7823 21.3331 10.9344 21.6843 10.3093 22.3094C9.6842 22.9345 9.33301 23.7823 9.33301 24.6664V26.6664C9.33301 27.02 9.47348 27.3592 9.72353 27.6092C9.97358 27.8593 10.3127 27.9997 10.6663 27.9997H29.333C29.6866 27.9997 30.0258 27.8593 30.2758 27.6092C30.5259 27.3592 30.6663 27.02 30.6663 26.6664V24.6664Z"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.667 33.3331H29.3337"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </Icon>
    )
}

export default ProductRegistrationIcon
